import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

/**
 * @purpose Maintain the catalog of bike models
 * @primary Bike models table
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/bike-models/")({
  validateSearch: listSearch,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
